import React from "react";
import { useHandleQdsSignatures } from "./hooks";
import { QdsSignature } from "../../store/qdsDocuments/QdsDocumentReducer";
import { useTranslation } from "react-i18next";

export const QdsSignInstructionPanel: React.FC = () => {
  const { signatures, removeSignature, handleCancelSigning, handleSubmitSigning } =
    useHandleQdsSignatures();

  const { t } = useTranslation();

  const grouped = signatures.reduce((acc: { [pageIndex: number]: QdsSignature[] }, sig: QdsSignature) => {
    if (!acc[sig.pageIndex]) acc[sig.pageIndex] = [];
    acc[sig.pageIndex].push(sig);
    return acc;
  }, {} as { [pageIndex: number]: QdsSignature[] });

  return (
    <div
      style={{
        padding: "20px",
        borderRadius: 4,
        backgroundColor: "#f9f9f9",
        maxWidth: 400,
        fontFamily: "sans-serif",
        maxHeight: "800px",
        overflowY: "auto",
      }}
    >
      <h3 style={{ marginBottom: 12 }}>{t("WEB_QDS_SIGNATURE.HOW_TO_SIGN")}</h3>
      <ol style={{ paddingLeft: 20, marginBottom: 20, fontSize: 14 }}>
        <li>{t("WEB_QDS_SIGNATURE.HOW_TO_SIGN_FIRST_INSTRUCTION")}</li>
        <li>{t("WEB_QDS_SIGNATURE.HOW_TO_SIGN_SECOND_INSTRUCTION")}</li>
        <li>{t("WEB_QDS_SIGNATURE.HOW_TO_SIGN_THIRD_INSTRUCTION")}</li>
        <li>{t("WEB_QDS_SIGNATURE.HOW_TO_SIGN_FOURTH_INSTRUCTION")}</li>
        <li>{t("WEB_QDS_SIGNATURE.HOW_TO_SIGN_FIFTH_INSTRUCTION")}</li>
      </ol>

      <button
        onClick={handleCancelSigning}
        className="btn btn-neutral"
        style={{
          width: "100%",
          height: 40,
          fontSize: 16,
          marginBottom: 12,
        }}
      >
        {t("WEB_QDS_SIGNATURE.CANCEL_SIGNING")}
      </button>

      <button
        onClick={handleSubmitSigning}
        className="btn btn-primary"
        style={{
          width: "100%",
          height: 40,
          fontSize: 16,
          borderRadius: 4,
          border: "none",
          marginBottom: 20,
        }}
      >
        {t("WEB_QDS_SIGNATURE.SUBMIT_SIGNED_DOCUMENT")}
      </button>

      <h4 style={{ marginBottom: 8 }}>{t("WEB_QDS_SIGNATURE.CURRENT_SIGNATURES")}</h4>

      {Object.keys(grouped).length === 0 ? (
        <p style={{ color: "#00264d", fontSize: 14 }}>{t("WEB_QDS_SIGNATURE.NO_SIGNATURES")}</p>
      ) : (
        Object.entries(grouped).map(([pageIndex, signs]) => (
          <div key={pageIndex} style={{ marginBottom: 16 }}>
            <strong style={{ display: "block", marginBottom: 6 }}>
              {t("UPLOAD.PAGE_NUM")} {+pageIndex + 1}:
            </strong>
            <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
              {(signs as QdsSignature[]).map((sig: QdsSignature) => (
                <li
                  key={sig.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "6px 0",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <img
                      src={sig.dataUrl}
                      alt={`Signature ${sig.id}`}
                      style={{
                        width: 60,
                        height: 40,
                        objectFit: "contain",
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        background: "#fff",
                      }}
                    />
                    <span style={{ fontSize: 14 }}>
                      {t("WEB_QDS_SIGNATURE.SIGNATURE")} #{sig.id}
                    </span>
                  </div>

                  <button
                    onClick={() => removeSignature(sig.id)}
                    style={{
                      background: "transparent",
                      color: "#dc3545",
                      border: "none",
                      cursor: "pointer",
                      fontSize: 16,
                    }}
                  >
                    {t("DELETE_BUTTON")}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
};

export default QdsSignInstructionPanel;
